<template>
  <transition name="slide-in">
    <div class="location-details-panel">
      <JsButton :fn="clearActiveLocation">
        <span class="mobile-button">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="25" viewBox="0 0 25 25" xml:space="preserve">
            <title>Back to results</title>
            <polyline id="Line" fill="none" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" points=" 14,19 7,12 14,5 "/>
            <path fill="#FFFFFF" d="M12.5,1C18.8,1,24,6.2,24,12.5S18.8,24,12.5,24S1,18.8,1,12.5S6.2,1,12.5,1 M12.5,0C5.6,0,0,5.6,0,12.5 S5.6,25,12.5,25S25,19.4,25,12.5S19.4,0,12.5,0L12.5,0z"/>
          </svg>
          Back to results
        </span>
        <span class="desktop-button">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26" height="26" viewBox="0 0 26 26" xml:space="preserve">
            <title>close x</title>
            <path fill="#FFFFFF" d="M13,1.5c6.3,0,11.5,5.2,11.5,11.5S19.3,24.5,13,24.5S1.5,19.3,1.5,13S6.7,1.5,13,1.5 M13,0.5 C6.1,0.5,0.5,6.1,0.5,13S6.1,25.5,13,25.5S25.5,19.9,25.5,13S19.9,0.5,13,0.5L13,0.5z"/>
            <polygon id="Shape" fill="#FFFFFF" points="19.5,7.8 18.2,6.5 13,11.7 7.8,6.5 6.5,7.8 11.7,13 6.5,18.2 7.8,19.5 13,14.3 18.2,19.5 19.5,18.2 14.3,13 "/>
          </svg>
        </span>
      </JsButton>

      <intro-block :heading="location.name" :content="location.intro" />

      <chart-data-panel :data="location.transactions.cards" />
      <chart-data-panel :data="location.transactions.contactless" themeColor="highlight" />
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import JsButton from './JsButton'
import IntroBlock from './IntroBlock'
import ChartDataPanel from './ChartDataPanel'

export default {
  name: 'location-details-panel',
  created () {
    window.scroll(0, 0)
  },
  methods: {
    ...mapMutations(['clearActiveLocation'])
  },
  computed: {
    ...mapGetters(['getActiveLocation', 'getActiveCategory'])
  },
  props: {
    location: {
      type: Object,
      required: true
    }
  },
  watch: {
    getActiveCategory (newVal, oldVal) {
      this.clearActiveLocation()
    }
  },
  components: {
    JsButton,
    IntroBlock,
    ChartDataPanel
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/variables';

  $button-height: 50px;

  .slide-in-enter-active,
  .slide-in-leave-active {
    transition: all $animation-timing-fn;
  }
  .slide-in-enter,
  .slide-in-leave-to {
    transform: translateX(-100%);
  }

  .location-details-panel {
    background: $brand-secondary;
    padding: $button-height + 15px 15px 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .button {
    background: $brand-primary !important;
    color: white;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    text-align: left;
    padding: 0 55px !important;
    display: flex;
    align-items: center;

    svg {
      position: absolute;
      top: 50%;
      left: 15px;
      transform: translateY(-50%);
    }
  }

  .desktop-button {
    display: none;
    top: 15px;
    right: 30px;
    width: 26px;
  }

  @media #{$breakpoint-md} {
    .location-details-panel {
      display: flex;
      justify-content: flex-end;
      z-index: 1;
    }

    .button {
      position: absolute;
      justify-content: flex-end;
      background: transparent !important;

      svg {
        left: inherit;
        right: 15px;
      }
    }

    .mobile-button {
      display: none;
    }

    .desktop-button {
      display: block;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/LocationDetailsPanel.vue